import React from 'react';
import '../template-file-css/document-file-template.css';



export const CBHS_AuthReferralRequestFormHumana = ({
   itemsRef,
   showErrorFor,

}) => {

   return (
      <form id='CBHS_AuthReferralRequestFormHumana' className='file-pdf-document'>
         <div className='file-template'>

            <p className='w-750'><center><h3>Behavioral Health Community Based Outpatient<br />Services Request Form </h3></center>
            </p>

            <p className='w-750'>
               Submit completed form electronically using our preferred method at Availity or by fax to 1-833-974-0059.
            </p>

            <table>
               <tr>
                  <td className='w-250'> <span className='eleHeader'>Today's date:</span>
                  </td>
                  <td className='w-250'> <span className='eleHeader'>Contact at provider's office:</span>
                  </td>
                  <td className='w-250'> <span className='eleHeader'>Secure fax:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'> <input type='date' id='txtTodayDate' name='txtTodayDate' className='add-only' />
                  </td>
                  <td className='w-250'> <input type='text' id='txtContact' name='txtContact' className='add-only' />
                  </td>
                  <td className='w-250'> <input type='text' id='txtSecureFax' name='txtSecureFax' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-450'> <span className='eleHeader'>Name of requestor:</span>
                  </td>
                  <td className='w-300'> <span className='eleHeader'>Phone:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-450'> <input type='text' id='txtNameOfRequestor' name='txtNameOfRequestor' className='add-only' />
                  </td>
                  <td className='w-300'> <input type='text' id='txtPhone' name='txtPhone' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'> <span className='eleHeader'>NPI:</span> </td>
                  <td className='w-375'> <span className='eleHeader'>TIN:</span> </td>
               </tr>
               <tr>
                  <td className='w-375'> <input type='text' id='txtNpi' name='txtNpi' className='add-only' /> </td>
                  <td className='w-375'> <input type='text' id='txtTin' name='txtTin' className='add-only' /> </td>
               </tr>
            </table>

            <p className='w-750'><b>Note:</b> Please provide appropriate contact information, including best working phone number for Humana staff to contact you if we need clarification or additional information to complete the request.
            </p>

            <p className='w-750'><center><h4>Member information</h4></center>
            </p>

            <table>
               <tr>
                  <td className='w-250'> <span className='eleHeader'>Last name:</span>
                  </td>
                  <td className='w-250'> <span className='eleHeader'>First name:</span> </td>
                  <td className='w-250'> <span className='eleHeader'>Humana ID:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-250'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                  <td className='w-250'> <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /> </td>
                  <td className='w-250'> <input type='text' id='HumanaId' name='HumanaId' className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-200'> <span className='eleHeader'>Date of birth:</span> </td>
                  <td className='w-350'> <span className='eleHeader'>Parent/guardian name:</span> </td>
                  <td className='w-200'> <span className='eleHeader'>Phone:</span> </td>
               </tr>
               <tr>
                  <td className='w-200'> <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' /> </td>
                  <td className='w-350'> <input type='text' id='txtParent' name='txtParent' className='add-only' /> </td>
                  <td className='w-200'> <input type='text' id='txtPhone1' name='txtPhone1' className='add-only' /> </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Is the member currently in coordinated system of care (CSoC)?</span>
               <input type='radio' id='rbCoordinatedSystem_Yes' name='rbCoordinatedSystem' className='add-only' value='Yes' /> Yes &nbsp;
               <input type='radio' id='rbCoordinatedSystem_No' name='rbCoordinatedSystem' className='add-only' value='No' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Authorization reference number(if applicable):</span>
               <input id='txtAuthorization' name='txtAuthorization' className='add-only' type='text' />
            </p>

            <p className='w-750'> <span className='eleHeader'>Services</span>
            </p>

            <table>
               <tr>
                  <td className='w-400'>
                     <input type='checkbox' id='cbServices_1' name='cbServices_1' className='add-only' value='Community psychiatric' /> Community psychiatric support and treatment (CPST)
                  </td>
                  <td className='w-350'>
                     <input type='checkbox' id='cbServices_2' name='cbServices_2' className='add-only' value='Functional Family' /> Functional Family Therapy (FFT)
                  </td>
               </tr>
               <tr>
                  <td className='w-400'>
                     <input type='checkbox' id='cbServices_3' name='cbServices_3' className='add-only' value='Psychosocial rehabilitation' /> Psychosocial rehabilitation (PSR)
                  </td>
                  <td className='w-350'>
                     <input type='checkbox' id='cbServices_4' name='cbServices_4' className='add-only' value='Assertive Community' /> Assertive Community Treatment (ACT)
                  </td>
               </tr>
               <tr>
                  <td className='w-400'>
                     <input type='checkbox' id='cbServices_5' name='cbServices_5' className='add-only' value='Electroconvulsive therapy' /> Electroconvulsive therapy (ECT)
                  </td>
                  <td className='w-350'>
                     <input type='checkbox' id='cbServices_6' name='cbServices_6' className='add-only' value='Home Builders' /> Home Builders (HB)
                  </td>
               </tr>
               <tr>
                  <td className='w-400'>
                     <input type='checkbox' id='cbServices_7' name='cbServices_7' className='add-only' value='Other' /> Other:
                     <input id='txtOther' name='txtOther' className='add-only' type='text' />
                  </td>
                  <td className='w-350'>
                     <input type='checkbox' id='cbServices_8' name='cbServices_8' className='add-only' value='Multisystemic therapy' /> Multisystemic therapy (MST)
                  </td>
               </tr>
            </table>

            <p className='w-750'><center><h3>Diagnosis code(s) and date(s) of service (DOS)</h3></center>
            </p>

            <table>
               <tr>
                  <td className='w-250'> <span className='eleHeader'>ICD-10*:</span> </td>
                  <td className='w-250'> <span className='eleHeader'>ICD-10*:</span> </td>
                  <td className='w-250'> <span className='eleHeader'>ICD-10*:</span> </td>
               </tr>
               <tr>
                  <td className='w-250'> <input type='text' id='txtParent_1' name='txtParent_1' className='add-only' /> </td>
                  <td className='w-250'> <input type='text' id='txtParent_2' name='txtParent_2' className='add-only' /> </td>
                  <td className='w-250'> <input type='text' id='txtParent_3' name='txtParent_3' className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-250'> <span className='eleHeader'>ICD-10*:</span> </td>
                  <td className='w-250'> <span className='eleHeader'>Start date of service:</span> </td>
                  <td className='w-250'> <span className='eleHeader'>End date of service:</span> </td>
               </tr>
               <tr>
                  <td className='w-250'> <input type='text' id='txtParent_4' name='txtParent_4' className='add-only' /> </td>
                  <td className='w-250'> <input type='date' id='txtStartDate' name='txtStartDate' className='add-only' /> </td>
                  <td className='w-250'> <input type='date' id='txtEndDate' name='txtEndDate' className='add-only' /> </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Type of request:</span>
               <input type='radio' id='rbRequest_Yes' name='rbRequest' className='add-only' value='Initial request' /> Initial request &nbsp;
               <input type='radio' id='rbRequest_No' name='rbRequest' className='add-only' value='Concurrent request' /> Concurrent request
            </p>

            <p className='w-750'><center><h3>Service code(s) including modifiers as indicated</h3></center>
            </p>

            <table>
               <tr>
                  <td className='w-200'> <span className='eleHeader'>Code:</span> </td>
                  <td className='w-200'> <span className='eleHeader'>Units:</span> </td>
                  <td className='w-350'> <span className='eleHeader'>Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-200'> <input type='text' id='txtCode_1' name='txtCode_1' className='add-only' /> </td>
                  <td className='w-200'> <input type='text' id='txtUnits_1' name='txtUnits_1' className='add-only' /> </td>
                  <td className='w-350'> <input type='text' id='txtFrequency_1' name='txtFrequency_1' className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-200'> <span className='eleHeader'>Code:</span> </td>
                  <td className='w-200'> <span className='eleHeader'>Units:</span> </td>
                  <td className='w-350'> <span className='eleHeader'>Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-200'> <input type='text' id='txtCode_2' name='txtCode_2' className='add-only' /> </td>
                  <td className='w-200'> <input type='text' id='txtUnits_2' name='txtUnits_2' className='add-only' /> </td>
                  <td className='w-350'> <input type='text' id='txtFrequency_2' name='txtFrequency_2' className='add-only' /> </td>
               </tr>
            </table>

            <p className='w-750'>* ICD-10 codes are from the International Classification of Diseases, Tenth Edition.
            </p>

            <p className='w-750'><b>Humana Healthy Horizons. in Louisiana</b>
            </p>

            <p className='w-750'>Humana Healthy Horizons in Louisiana is a Medicaid Product of Humana Benefit Plan of Louisiana, Inc.
            </p>

            <p className='w-750'><center><h3>Service code(s) including modifiers as indicated</h3></center>
            </p>

            <table>
               <tr>
                  <td className='w-200'> <span className='eleHeader'>Code:</span> </td>
                  <td className='w-200'> <span className='eleHeader'>Units:</span> </td>
                  <td className='w-350'> <span className='eleHeader'>Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-200'> <input type='text' id='txtCode_3' name='txtCode_3' className='add-only' /> </td>
                  <td className='w-200'> <input type='text' id='txtUnits_3' name='txtUnits_3' className='add-only' /> </td>
                  <td className='w-350'> <input type='text' id='txtFrequency_3' name='txtFrequency_3' className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-200'> <span className='eleHeader'>Code:</span> </td>
                  <td className='w-200'> <span className='eleHeader'>Units:</span> </td>
                  <td className='w-350'> <span className='eleHeader'>Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-200'> <input type='text' id='txtCode_4' name='txtCode_4' className='add-only' /> </td>
                  <td className='w-200'> <input type='text' id='txtUnits_4' name='txtUnits_4' className='add-only' /> </td>
                  <td className='w-350'> <input type='text' id='txtFrequency_4' name='txtFrequency_4' className='add-only' /> </td>
               </tr>
               <tr>
                  <td className='w-200'> <span className='eleHeader'>Code:</span> </td>
                  <td className='w-200'> <span className='eleHeader'>Units:</span> </td>
                  <td className='w-350'> <span className='eleHeader'>Frequency:</span> </td>
               </tr>
               <tr>
                  <td className='w-200'> <input type='text' id='txtCode_5' name='txtCode_5' className='add-only' /> </td>
                  <td className='w-200'> <input type='text' id='txtUnits_5' name='txtUnits_5' className='add-only' /> </td>
                  <td className='w-350'> <input type='text' id='txtFrequency_5' name='txtFrequency_5' className='add-only' /> </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Diagnosis</span><span className='small'>(psychiatric, chemical dependency and medical)</span>
               <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Current behavioral health services and providers</span>
               <textarea id='txtCurrentBehavioral' name='txtCurrentBehavioral' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Previous behavioral health services and providers</span>
               <textarea id='txtPreviousBehavioral' name='txtPreviousBehavioral' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Risk of harm to self (within the past 24 to 48 hours) </span>If present, describe:
               <textarea id='txtRiskHarm' name='txtRiskHarm' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Risk of harm to self </span> <span className='small'>If prior attempt, date and description:</span>
               <textarea id='txtRiskHarm_1' name='txtRiskHarm_1' className='add-only'></textarea>
            </p>

            <p className='w-750'>
               <span className='eleHeader'>Risk rating </span><span className='small'>(select all that apply)</span>
            </p>

            <table>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_1' name='cbRiskRating_1' className='add-only' value='Not present' /> Not present
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_2' name='cbRiskRating_2' className='add-only' value='Ideation' /> Ideation
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_3' name='cbRiskRating_3' className='add-only' value='Plan' /> Plan
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_4' name='cbRiskRating_4' className='add-only' value='Means' /> Means
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_5' name='cbRiskRating_5' className='add-only' value='Prior attempt' /> Prior attempt
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Risk of harm to others (within the past 24 to 48 hours)</span>If present, describe:
               <textarea id='txtRiskHarm_2' name='txtRiskHarm_2' className='add-only'></textarea>
            </p>
            <p className='w-750'>
               <span className='small'>If prior attempt, date and description:</span>
               <textarea id='txtRiskHarm_3' name='txtRiskHarm_3' className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Risk rating </span><span className='small'>(select all that apply)</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_6' name='cbRiskRating_6' className='add-only' value='Not present' /> Not present
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_7' name='cbRiskRating_7' className='add-only' value='Ideation' /> Ideation
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_8' name='cbRiskRating_8' className='add-only' value='Plan' /> Plan
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_9' name='cbRiskRating_9' className='add-only' value='Means' /> Means
                  </td>
                  <td className='w-150'>
                     <input type='checkbox' id='cbRiskRating_10' name='cbRiskRating_10' className='add-only' value='Prior attempt' /> Prior attempt
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Medications-please list current and previous</span>
               <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
            </p>

            <p className='w-750'>
               <span className='eleHeader'>Is member compliant with medications?</span>
               <input type='radio' id='rbMedications_Yes' name='rbMedications' className='add-only' value='Yes' /> Yes &nbsp;
               <input type='radio' id='rbMedications_No' name='rbMedications' className='add-only' value='No' /> No
            </p>

            <p className='w-750'>Assessments-please attach to request
            </p>

            <p className='w-750'>
               <span className='eleHeader'>Level of Care Utilization System (LOCUS) or Child/Adolescent Level of Care Utilization System (CALOCUS) date:</span>
               <input type='date' id='txtUtilization' name='txtUtilization' className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Licensed mental health professional (LMHP) name:</span>
               <input type='text' id='txtLicensed' name='txtLicensed' className='add-only' />
            </p>

            <p className='w-750'>
               <b>Treatment plan:</b>Indicate the service (e.g., CPST or PSR) and interventions, the duration and frequency for each and the time needed to complete them.
            </p>

            <p className='w-750'>
               <span className='eleHeader'>Goal</span>
               <input type='text' id='txtGoal_1' name='txtGoal_1' className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Service</span>
               <input type='text' id='txtService_1' name='txtService_1' className='add-only' />
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Type of intervention</span>
                     <input type='text' id='txtIntervention_1' name='txtIntervention_1' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Duration and frequency</span>
                     <input type='text' id='txtDuration_1' name='txtDuration_1' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Length of intervention</span>
                     <input type='text' id='txtLength_1' name='txtLength_1' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Who will provide intervention?</span>
                     <input type='text' id='txtProvide_1' name='txtProvide_1' className='add-only' />
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Goal</span>
               <input type='text' id='txtGoal_2' name='txtGoal_2' className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Service</span>
               <input type='text' id='txtService_2' name='txtService_2' className='add-only' />
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Type of intervention</span>
                     <input type='text' id='txtIntervention_2' name='txtIntervention_2' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Duration and frequency</span>
                     <input type='text' id='txtDuration_2' name='txtDuration_2' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Length of intervention</span>
                     <input type='text' id='txtLength_2' name='txtLength_2' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Who will provide intervention?</span>
                     <input type='text' id='txtProvide_2' name='txtProvide_2' className='add-only' />
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Goal</span>
               <input type='text' id='txtGoal_3' name='txtGoal_3' className='add-only' />
            </p>
            <p className='w-750'>
               <span className='eleHeader'>Service</span>
               <input type='text' id='txtService_3' name='txtService_3' className='add-only' />
            </p>
            <table>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Type of intervention</span>
                     <input type='text' id='txtIntervention_3' name='txtIntervention_3' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Duration and frequency</span>
                     <input type='text' id='txtDuration_3' name='txtDuration_3' className='add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <span className='eleHeader'>Length of intervention</span>
                     <input type='text' id='txtLength_3' name='txtLength_3' className='add-only' />
                  </td>
                  <td className='w-375'>
                     <span className='eleHeader'>Who will provide intervention?</span>
                     <input type='text' id='txtProvide_3' name='txtProvide_3' className='add-only' />
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>If requesting to provide both CPST and PSR, please explain the need for both services and how they will differ in delivery.</span>
               <textarea id='txtRequesting' name='txtRequesting' className='add-only'></textarea>
            </p>

            <p className='w-750'>
               <span className='eleHeader'>Has the member displayed any of the following within the past month?</span>
            </p>

            <p className='w-750'>
               <input type='checkbox' id='cbAngry_1' name='cbAngry_1' className='add-only' value='Angry outburst' /> Angry outburst/aggression
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_2' name='cbAngry_2' className='add-only' value='Arrest' /> Arrest/confirmed illegal activity
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_3' name='cbAngry_3' className='add-only' value='Inability to utilize' /> Inability to utilize or absence of formal
               or informal supports
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_4' name='cbAngry_4' className='add-only' value='Substance use' /> Substance use disorder (SUD)
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_5' name='cbAngry_5' className='add-only' value='Hypomanic' /> Hypomanic or hypermanic symptoms
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_6' name='cbAngry_6' className='add-only' value='Lack of motivation' /> Lack of motivation for SUD treatment
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_7' name='cbAngry_7' className='add-only' value='Nonsuicidal' /> Nonsuicidal self-injury
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_8' name='cbAngry_8' className='add-only' value='Delusions' /> Delusions/hallucinations
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_9' name='cbAngry_9' className='add-only' value='Obsessions' /> Obsessions or compulsions
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_10' name='cbAngry_10' className='add-only' value='Destruction' /> Destruction of property
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_11' name='cbAngry_11' className='add-only' value='Repeated acute' /> Repeated acute psychiatric hospitalizations
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_12' name='cbAngry_12' className='add-only' value='Disorganized' /> Disorganized thoughts, speech or behavior
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_13' name='cbAngry_13' className='add-only' value='Psychiatric medication' /> Psychiatric medication noncompliance
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_14' name='cbAngry_14' className='add-only' value='Difficulty with activities' /> Difficulty with activities of daily living (ADLs) such as cooking, bathing, financial management, etc.
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry-15' name='cbAngry-15' className='add-only' value='Sexually abusive' /> Sexually abusive/threatening behavior
            </p>
            <p className='w-750'>
               <input type='checkbox' id='cbAngry_16' name='cbAngry_16' className='add-only' value='Suicidal ideations' /> Suicidal ideations
            </p>

            <p className='w-750'>
               <span className='eleHeader'>Have any of these behaviors persisted for at least 6 months?</span>
               <input type='radio' id='rbBehaviors_Yes' name='rbBehaviors' className='add-only' value='Yes' /> Yes &nbsp;
               <input type='radio' id='rbBehaviors_No' name='rbBehaviors' className='add-only' value='No' /> No
            </p>
            <p className='w-750'>
               <span className='eleHeader'>If yes, please explain:</span>
               <textarea id='txtExplain' name='txtExplain' className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>Has the member had unsuccessful treatment or lack of improvement in any of the following
                        within the past month?</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbGroup_1' name='cbGroup_1' className='add-only' value='Group home' /> Group home
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbGroup_2' name='cbGroup_2' className='add-only' value='Outpatient therapy services' /> Outpatient therapy services
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbGroup_3' name='cbGroup_3' className='add-only' value='Psychiatric inpatient services' /> Psychiatric inpatient services
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbGroup_4' name='cbGroup_4' className='add-only' value='Residential treatment' /> Residential treatment
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbGroup_5' name='cbGroup_5' className='add-only' value='SUD treatment' /> SUD treatment
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbGroup_6' name='cbGroup_6' className='add-only' value='Therapeutic group home' /> Therapeutic group home
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                     <input type='checkbox' id='cbGroup_7' name='cbGroup_7' className='add-only' value='Mental health rehabilitation' /> Mental health rehabilitation services (CPST, PSR, HB, FFT, MST)
                  </td>
               </tr>
            </table>

            <p className='w-750'>
               <span className='eleHeader'>Please describe the member's support system:</span>
               <textarea id='txtSystem' name='txtSystem' className='add-only'></textarea>
            </p>
            <table>
               <tr>
                  <td className='w-750'>
                     <span className='eleHeader'>The member displays severe impairment in the following areas:</span>
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbWork_1' name='cbWork_1' className='add-only' value='ADLs' /> ADLs
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbWork_2' name='cbWork_2' className='add-only' value='Work performance' /> Work performance
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbWork_3' name='cbWork_3' className='add-only' value='Community living' /> Community living
                  </td>
                  <td className='w-375'>
                     <input type='checkbox' id='cbWork_4' name='cbWork_4' className='add-only' value='Social relationships' /> Social relationships
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type='checkbox' id='cbWork_5' name='cbWork_5' className='add-only' value='Family relationships' /> Family relationships
                  </td>
               </tr>
            </table>
            
            <p className='w-750'><b>For continued stay requests, please complete the following:</b>
            </p>

            <p className='w-750'>
                     <span className='eleHeader'>Within the past month, has the member experienced and/or displayed the following:</span>
                  </p>
               
            <table>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_1" name="cbObsessions_1" className="add-only" value="After-hours crises" /> After-hours crises
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_2" name="cbObsessions_2" className="add-only" value="Obsessions" /> Obsessions/compulsions
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_3" name="cbObsessions_3" className="add-only" value="Anger outbursts" /> Anger outbursts
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_4" name="cbObsessions_4" className="add-only"value="Physical altercations" /> Physical altercations
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_5" name="cbObsessions_5" className="add-only" value="Arrests" /> Arrests
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_6" name="cbObsessions_6" className="add-only" value="Poor boundaries" /> Poor boundaries
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_7" name="cbObsessions_7" className="add-only" value="Depressed mood" /> Depressed mood
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_8" name="cbObsessions_8" className="add-only" value="Post-traumatic stress" /> Post-traumatic stress disorder or trauma
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_9" name="cbObsessions_9" className="add-only" value="Destruction of property" /> Destruction of property
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_10" name="cbObsessions_10" className="add-only" value="noncompliance" /> Psychiatric medication noncompliance
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_11" name="cbObsessions_11" className="add-only" value="Distractibility" /> Distractibility
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_12" name="cbObsessions_12" className="add-only" value="Psychosis" /> Psychosis
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_13" name="cbObsessions_13" className="add-only" value="Homicidal ideations" /> Homicidal ideations
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_14" name="cbObsessions_14" className="add-only" value="Serious rule" /> Serious rule violations
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_15" name="cbObsessions_15" className="add-only" value="Hypomanic symptoms" /> Hypomanic symptoms
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_16" name="cbObsessions_16" className="add-only" value="Stalking" /> Stalking
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_17" name="cbObsessions_17" className="add-only" value="Isolation" /> Isolation
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_18" name="cbObsessions_18" className="add-only" value="SUD with high risk" /> SUD with high risk of relapse
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_19" name="cbObsessions_19" className="add-only" value="daily structure" /> Job or daily structure activities interrupted
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_20" name="cbObsessions_20" className="add-only" value="Suicidal ideations" /> Suicidal ideations
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_21" name="cbObsessions_21" className="add-only" value="Manipulative behavior" /> Manipulative behavior
                  </td>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_22" name="cbObsessions_22" className="add-only" value="Theft" /> Theft
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_23" name="cbObsessions_23" className="add-only" value="Neglect of ADLs" /> Neglect of ADLs
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                     <input type="checkbox" id="cbObsessions_24" name="cbObsessions_24" className="add-only" value="Other" /> Other:
                     <input id="txtProvideOther" name="txtProvideOther" className="add-only" type="text" />
                  </td>
               </tr>
            </table>
            <p className='w-750'>
               <span className="eleHeader">Please describe progress, improvement and/or lack of, since beginning current service.</span>
               <textarea id="txtProgress_1" name="txtProgress_1" className="add-only"></textarea>
            </p>
            <p className='w-750'>
               <span className="eleHeader">Please indicate why a lower level of care would not be appropriate at this time.</span>
               <textarea id="txtProgress_2" name="txtProgress_2" className="add-only"></textarea>
            </p>
            <p className='w-750'>
               <span className="eleHeader">Please indicate discharge plan for member, including anticipated time frames and follow-up services.</span>
               <textarea id="txtProgress_3" name="txtProgress_3" className="add-only"></textarea>
            </p>
            <p className='w-750'>
               <span className="eleHeader">Please provide any additional clinical information to support the medical necessity of the requested services.</span>
               <textarea id="txtProgress_4" name="txtProgress_4" className="add-only"></textarea>
            </p>
            <table>
               <tr>
                  <td className='signature w-500'>
                     &nbsp;
                  </td>
                  <td className='signature w-250'>
                     &nbsp;
                  </td>
               </tr>
               <tr>
                  <td className="small w-500">
                     Submitted by:
                  </td>
                  <td className="small w-250">
                     Date:
                  </td>
               </tr>
            </table>

         </div>
      </form>

   )
}











